<div class="flex-container-column-center height-100 bg-auth-accent">
	<ion-header class="ion-no-border">
		<div class="width-100 flex-container-row-nowrap justify-content-space-between box-sizing-border-box">
			<button class="button-reset btn--text padding-16px color-light-gray-on-accent" (click)="selectOrganisation()">
				<i class="fa fa-caret-left vertical-align-middle margin-right-4px"></i
				><span class="font-size-0-8rem">{{ "general.change_organisation" | translate }}</span>
			</button>
			<ic-change-language class="margin-top-4px margin-right-8px color-light-gray-on-accent" />
		</div>
		<ic-app-sunset-banner
			class="ion-align-self-stretch"
			[dataWarning]="clientCheckQuery.data()?.data?.clientVersion?.warning"
		/>
	</ion-header>
	<div class="position-relative margin-top-auto btn-wrapper" [class.loading]="loading$ | async">
		<button
			class="button-reset btn btn--secondary"
			data-test="button-login-with-organisation"
			[disabled]="loading$ | async"
			(click)="login()"
		>
			{{ "auth.signin_with" | translate }} {{ orgName$ | async }}
		</button>
		<loading-indicator class="pointer-events-none" [running]="loading$ | async" [size]="24" />
	</div>
	@if (error$ | async) {
		<div class="margin-top-1rem color-light-gray-on-accent">
			<i class="fa fa-exclamation-triangle"></i> {{ error$ | async | translate }}
		</div>
	}
	<div class="text-uppercase divider">
		{{ "general.or" | translate }}
	</div>
	<button
		class="button-reset btn btn--primary"
		data-test="button-login-with-username"
		[disabled]="loading$ | async"
		(click)="localLogin()"
	>
		{{ "auth.signin_with_username" | translate }}
	</button>
	<div
		class="width-100 text-align-center font-size-0-8rem color-light-gray-on-accent margin-top-auto margin-bottom-1rem"
	>
		{{ "settings.version" | translate }} {{ appVersion }}
	</div>
</div>
